import type { CreditDenialScope } from './types';

/**
 * `ORGANIZATION` draws from a shared pool with no individual limit to raise, and `UNKNOWN`
 * carries nothing actionable, so neither offers "Request credits".
 *
 * A missing scope is deliberately permissive so hosts that predate `scope` keep their existing
 * banner. Real denials never hit that path: the backend client maps any unrecognised scope to
 * `UNKNOWN`, so a denial is always one of the four known values.
 */
export const canScopeRequestCredits = (scope?: CreditDenialScope): boolean =>
	scope !== 'ORGANIZATION' && scope !== 'UNKNOWN';

/**
 * `UNKNOWN` shows the generic message only, so it never shows a reset date. A missing scope is
 * permissive for the same reason as `canScopeRequestCredits`.
 */
export const canScopeShowResetDate = (scope?: CreditDenialScope): boolean => scope !== 'UNKNOWN';
